<template>
  <div class="customer-photo-container mr-4">
    <img v-if="customerImage" :src="customerImage" alt class="customer-photo-el" />
    <svg class="customer-photo-el" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <title>image-placeholder</title>
      <rect fill="#efeeee" width="60" height="60" />
      <path
        fill="#fff"
        d="M41.5,19.38h-23A2.65,2.65,0,0,0,15.85,22V38a2.65,2.65,0,0,0,2.65,2.66h23A2.65,2.65,0,0,0,44.15,38V22A2.65,2.65,0,0,0,41.5,19.38ZM42.38,38a.88.88,0,0,1-.88.89h-23a.88.88,0,0,1-.88-.89V22a.88.88,0,0,1,.88-.89h23a.88.88,0,0,1,.88.89ZM22,28.67a3.1,3.1,0,1,0-3.1-3.09A3.09,3.09,0,0,0,22,28.67Zm0-4.42a1.33,1.33,0,1,1-1.33,1.33A1.34,1.34,0,0,1,22,24.25Zm11.44,1.27-5.25,5.26-1.71-1.72a1.33,1.33,0,0,0-1.88,0l-4.87,4.87a1.32,1.32,0,0,0-.39.94v1.54a.67.67,0,0,0,.67.67H40a.67.67,0,0,0,.67-.67V31.33a1.33,1.33,0,0,0-.39-.94l-4.87-4.87A1.35,1.35,0,0,0,33.48,25.52Zm5.37,9.79H21.15v-.26l4.43-4.42,2.65,2.65,6.19-6.19,4.43,4.42Z"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    customerImage: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.customer-photo-container {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  overflow: hidden;
}

.customer-photo-el {
  width: 100%;
  height: 100%;
}
</style>
